export interface ColumnConfig {
  column_id: 'name' | 'type' | 'owner' | 'position' | 'position_value' | 'template' | 'gift_name' | 'source' | 'projected_amount' | 'amount';
  column_label: string;
  column_type: 'text' | 'percentage' | 'currency';
  text_align?: 'left' | 'center' | 'right';
  width?: string;
}

export interface TableConfig {
  columns: ColumnConfig[];
  summary?: { enabled: boolean; label: string; currencyColumnId?: 'position_value' | 'projected_amount' | 'amount' };
  propertyMap: { [columnId: string]: string };
}

export interface CategorizedTableData {
  key: 'assets' | 'liabilities' | 'entities' | 'specific_gifts' | 'general_gifts' | 'residuary_gifts';
  title: string;
  items: any[];
  searchBoxPlaceHolder?: string;
  tableConfig: TableConfig;
  allUserInstanceForms?: any[];
  autoAddIsEnabled?: boolean;
  linkedItems?: any[];
}

export const ASSETS_TABLE_CONFIG: TableConfig = {
  columns: [
    { column_id: 'name', column_label: 'Name', column_type: 'text', text_align: 'left' },
    { column_id: 'type', column_label: 'Type', column_type: 'text', text_align: 'center' },
    { column_id: 'position', column_label: 'Current Position', column_type: 'percentage' },
    { column_id: 'position_value', column_label: 'Position Value', column_type: 'currency' },
  ],
  summary: { enabled: true, label: 'Net Assets', currencyColumnId: 'position_value' },
  propertyMap: { name: 'form_name', type: 'vault_form_type', position: 'net_amount', position_value: 'position_value' },
} as const;

export const LIABILITIES_TABLE_CONFIG: TableConfig = {
  columns: [
    { column_id: 'name', column_label: 'Name', column_type: 'text', text_align: 'left' },
    { column_id: 'type', column_label: 'Type', column_type: 'text', text_align: 'center' },
    { column_id: 'position', column_label: 'Current Position', column_type: 'percentage' },
    { column_id: 'position_value', column_label: 'Position Balance', column_type: 'currency' },
  ],
  summary: { enabled: true, label: 'Net Liabilities', currencyColumnId: 'position_value' },
  propertyMap: { name: 'form_name', type: 'vault_form_type', position: 'net_amount', position_value: 'position_value' },
} as const;

export const ENTITIES_TABLE_CONFIG: TableConfig = {
  columns: [
    { column_id: 'name', column_label: 'Name', column_type: 'text', text_align: 'left' },
    { column_id: 'type', column_label: 'Type', column_type: 'text', text_align: 'center' },
    { column_id: 'position', column_label: 'Current Position', column_type: 'percentage' },
  ],
  summary: { enabled: false, label: '' },
  propertyMap: { name: 'form_name', type: 'vault_form_type', position: 'net_amount' },
} as const;

export const SPECIFIC_GIFTS_TABLE_CONFIG: TableConfig = {
  columns: [
    { column_id: 'template', column_label: 'Name', column_type: 'text', text_align: 'left' },
    { column_id: 'owner', column_label: 'Source', column_type: 'text', text_align: 'center' },
    // { column_id: 'position', column_label: 'Current Position', column_type: 'percentage' },
    { column_id: 'position_value', column_label: 'Value Estimate', column_type: 'currency' },
  ],
  summary: { enabled: true, label: 'Net Specific Gifts', currencyColumnId: 'position_value' },
  propertyMap: {
    template: 'form_name',
    owner: 'gift_owner_name',
    // position: 'role_player_percent',
    position_value: 'position_value',
  },
} as const;

export const GENERAL_GIFTS_TABLE_CONFIG: TableConfig = {
  columns: [
    { column_id: 'gift_name', column_label: 'Name', column_type: 'text', text_align: 'left' },
    { column_id: 'source', column_label: 'Source', column_type: 'text', text_align: 'center' },
    { column_id: 'amount', column_label: 'Value Estimate', column_type: 'currency' },
  ],
  summary: { enabled: true, label: 'Net General Gifts', currencyColumnId: 'amount' },
  propertyMap: {
    gift_name: 'gift_name',
    source: 'form_name',
    amount: 'cost',
  },
} as const;

export const RESIDUARY_GIFTS_TABLE_CONFIG: TableConfig = {
  columns: [
    { column_id: 'gift_name', column_label: 'Gift Name', column_type: 'text', text_align: 'left' },
    { column_id: 'source', column_label: 'Source', column_type: 'text', text_align: 'center' },
    { column_id: 'projected_amount', column_label: 'Value Estimate', column_type: 'currency' },
  ],
  summary: { enabled: true, label: 'Net Residuary Gifts', currencyColumnId: 'projected_amount' },
  propertyMap: {
    gift_name: 'gift_name',
    source: 'form_name',
    projected_amount: 'cost',
  },
} as const;

export const TABLE_CONFIG_BY_CATEGORY = {
  assets: ASSETS_TABLE_CONFIG,
  liabilities: LIABILITIES_TABLE_CONFIG,
  entities: ENTITIES_TABLE_CONFIG,
  specific_gifts: SPECIFIC_GIFTS_TABLE_CONFIG,
  general_gifts: GENERAL_GIFTS_TABLE_CONFIG,
  residuary_gifts: RESIDUARY_GIFTS_TABLE_CONFIG,
} as const;
